import { render, staticRenderFns } from "./pix.vue?vue&type=template&id=55eef109&"
import script from "./pix.vue?vue&type=script&lang=js&"
export * from "./pix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55eef109')) {
      api.createRecord('55eef109', component.options)
    } else {
      api.reload('55eef109', component.options)
    }
    module.hot.accept("./pix.vue?vue&type=template&id=55eef109&", function () {
      api.rerender('55eef109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/order/pix.vue"
export default component.exports